import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexYAxis,
  ApexGrid,
  ApexDataLabels,
  ApexStroke,
  ApexTitleSubtitle,
  ApexTooltip,
  ApexLegend,
  ApexPlotOptions,
  ApexFill,
  ApexMarkers,
  ApexTheme,
  ApexNonAxisChartSeries,
  ApexResponsive,
  ChartComponent
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexAxisChartSeries | ApexNonAxisChartSeries;
  colors: string[],
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis | ApexYAxis[],
  title: ApexTitleSubtitle;
  dataLabels: ApexDataLabels,
  stroke: ApexStroke,
  grid: ApexGrid,
  legend?: ApexLegend,
  tooltip?: ApexTooltip,
  plotOptions?: ApexPlotOptions,
  labels?: string[],
  fill: ApexFill,
  markers?: ApexMarkers,
  theme: ApexTheme,
  responsive: ApexResponsive[]
};
import { BmxDollar } from 'app/oDres/modelos/Dashboard/bmx';
import { LoadingService } from 'app/shared/services/loading.service';
import { GeneralesService } from 'app/shared/services/general.service';
import { AuthService } from 'app/shared/auth/auth.service';
import { DatosDashboardVentas } from 'app/oDres/modelos/Dashboard/datosDashboardVentas';

@Component({
  selector: 'app-tipo-cambio-dollar',
  templateUrl: './tipo-cambio-dollar.component.html',
  styleUrls: ['./tipo-cambio-dollar.component.scss']
})
export class TipoCambioDollarComponent implements OnInit {

  @ViewChild("chartDollarFix") chartDollarFix: ChartComponent;
  @ViewChild("chartDollarCierre") chartDollarCierre: ChartComponent;

  datosChart: any;

  dollarDia = "";
  dollarDiaCierre = "";

  fecha1 = "";
  fecha2 = "";

  chartDollarFixoptions: Partial<ChartOptions>;
  chartDollarCierreoptions: Partial<ChartOptions>;

  fechaFix = "";
  fechaCierre = "";

  esMayorFix = false;
  esMayorCierre = false;

  datosDashboardVentas: DatosDashboardVentas = {};

  constructor(public authService: AuthService, private generalesService: GeneralesService, private loadingService: LoadingService, private cdRef: ChangeDetectorRef) { }

  commonOptions: Partial<ChartOptions> = {
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: "straight"
    },
    // toolbar: {
    //   tools: {
    //     selection: false
    //   }
    // },
    markers: {
      size: 6,
      hover: {
        size: 10
      }
    },
    tooltip: {
      followCursor: false,
      theme: "light",
      x: {
        show: false
      },
      marker: {
        show: false
      },
      y: {
        title: {
          formatter: function () {
            return "";
          }
        }
      }
    },
    grid: {
      //clipMarkers: false
    },
    xaxis: {
      type: "datetime"
    }
  };

  ngOnInit(): void {
    this.obtenerDatosDashboardVentas();
  }

  obtenerDatosDashboardVentas() {

    this.loadingService.show("Obteniendo información de dashboard...");

    this.generalesService.obtenerDatosDashboardVentas(this.authService.usuarioConectado.Empresa.IdEmpresa).subscribe(datos => {

      if (datos != null && datos.code == 200) {

        this.datosDashboardVentas = datos.model;

        //#region Grafica de Dollar

        let respuesta: BmxDollar = this.datosDashboardVentas.respuestaBmx;

        this.datosChart = { labels: [], series: [[]] };

        this.datosChart.series = [];

        this.fecha1 = moment().subtract(30, 'days').format('DD/MM/YYYY');

        this.fecha2 = moment().format('DD/MM/YYYY');

        let datosDollar = [];

        let datosDollarCierre = [];

        respuesta.bmx.series.forEach(serie => {

          let arregloSerie = []

          if (serie.idSerie == 'SF43718') {
            serie.datos.forEach(fix => {
              this.datosChart.labels.push(fix.fecha.substring(0, 2));
              arregloSerie.push(+fix.dato);

              let fecha = fix.fecha.substring(0, 2);

              let mes = fix.fecha.substring(5, 3);

              let year = fix.fecha.substring(10, 6);

              switch (mes) {

                case '01':
                  fecha += ' Jan ' + year
                  break;

                case '02':
                  fecha += ' Feb ' + year
                  break;

                case '03':
                  fecha += ' Mar ' + year
                  break;

                case '04':
                  fecha += ' Apr ' + year
                  break;

                case '05':
                  fecha += ' May ' + year
                  break;

                case '06':
                  fecha += ' Jun ' + year
                  break;

                case '07':
                  fecha += ' Jul ' + year
                  break;

                case '08':
                  fecha += ' Aug ' + year
                  break;

                case '09':
                  fecha += ' Sep ' + year
                  break;

                case '10':
                  fecha += ' Oct ' + year
                  break;

                case '11':
                  fecha += ' Nov ' + year
                  break;

                case '12':
                  fecha += ' Dec ' + year
                  break;

              }

              datosDollar.push([new Date(fecha).getTime(), +fix.dato]);
            });
          }
          else {
            serie.datos.forEach(fix => {
              this.datosChart.labels.push(fix.fecha.substring(0, 2));
              arregloSerie.push(+fix.dato);

              let fecha = fix.fecha.substring(0, 2);

              let mes = fix.fecha.substring(5, 3);

              let year = fix.fecha.substring(10, 6);

              switch (mes) {

                case '01':
                  fecha += ' Jan ' + year
                  break;

                case '02':
                  fecha += ' Feb ' + year
                  break;

                case '03':
                  fecha += ' Mar ' + year
                  break;

                case '04':
                  fecha += ' Apr ' + year
                  break;

                case '05':
                  fecha += ' May ' + year
                  break;

                case '06':
                  fecha += ' Jun ' + year
                  break;

                case '07':
                  fecha += ' Jul ' + year
                  break;

                case '08':
                  fecha += ' Aug ' + year
                  break;

                case '09':
                  fecha += ' Sep ' + year
                  break;

                case '10':
                  fecha += ' Oct ' + year
                  break;

                case '11':
                  fecha += ' Nov ' + year
                  break;

                case '12':
                  fecha += ' Dec ' + year
                  break;

              }

              datosDollarCierre.push([new Date(fecha).getTime(), +fix.dato]);
            });
          }

          this.datosChart.series.push(arregloSerie);

        });

        this.chartDollarFixoptions = {
          series: [
            {
              name: "chartDollarFix",
              data: datosDollar
            }
          ],
          chart: {
            id: "fb",
            group: "social",
            type: "area",
            height: 160
          },
          colors: ["#008FFB"],
          yaxis: {
            tickAmount: 2,
            labels: {
              minWidth: 40
            }
          }
        };

        this.chartDollarCierreoptions = {
          series: [
            {
              name: "chartDollarCierre",
              data: datosDollarCierre
            }
          ],
          chart: {
            id: "tw",
            group: "social",
            type: "area",
            height: 160
          },
          colors: ["#3daa24"],
          yaxis: {
            tickAmount: 2,
            labels: {
              minWidth: 40
            }
          }
        };

        //#endregion

        //#region Comparacion Dollar

        this.dollarDia = this.datosDashboardVentas.respuestaTipCambFix.body[0].mensaje;
        this.fechaFix = moment(this.datosDashboardVentas.respuestaTipCambFix.fecha).toDate().toDateString();
        this.esMayorFix = this.datosDashboardVentas.respuestaTipCambFix.esMayor;

        this.dollarDiaCierre = this.datosDashboardVentas.respuestaTipCambCierre.body[0].mensaje;
        this.fechaCierre = moment(this.datosDashboardVentas.respuestaTipCambCierre.fecha).toDate().toDateString();
        this.esMayorCierre = this.datosDashboardVentas.respuestaTipCambCierre.esMayor;

        //#endregion

        window.dispatchEvent(new Event('resize'));

      }

      this.loadingService.hide();
      this.cdRef.detectChanges();

    });

  }
}
